import { useNavigate } from 'react-router-dom'

export const BackButton = () => {
    const navigate = useNavigate()
    return (
        <div className='flex rounded-full absolute -top-[13px] z-10 justify-center'>
            <button onClick={() => navigate('..')} className='hover:shadow-sm hover:shadow-gray-300 hover:dark:shadow-gray-600 hover:dark:text-gray-200 rounded-full py-0 text-gray-400 hover:text-gray-600 dark:text-gray-600 dark:hover:text-gray-700 flex' title='Volver'>
                <i className='fa-solid fa-circle-arrow-left text-[25px] rounded-t-md' />
            </button>
        </div>
    )
}
